// 需求大厅
<template>
  <div>
    <el-row type="flex" justify="center" class="customFadeInDown delay-0-1s slow">
    	<el-col :span="24">
    		<el-row><el-image :src="banner"></el-image></el-row>
    	</el-col>
    </el-row>
    <el-row justify="center" type="flex" class="customFadeInDown delay-0-2s slow">
      <el-col :span="11" class="list-container">
        <!-- 查询条件 -->
        <div class="card-group-top font-small">
          <el-row class="bottom-margin" justify="start" type="flex">
            <span class="tag-group-item right-margin">服务类型：</span>
            <span v-for="(item, index) in serviceTypeDict.list"
                  :key="index" @click="handleTagChange('SERVICE', item, index)"
                  :class="index == serviceTypeDict.activeIndex ? 'active-tag' : ''"
                  class="tag-group-item right-margin cursor-default">{{item.dictLabel}}</span>
          </el-row>
          <el-row class="bottom-margin" justify="start" type="flex">
            <span class="tag-group-item right-margin">行业类型：</span>
            <span v-for="(item, index) in industryClassifyDict.list"
                  :key="index" @click="handleTagChange('INDUSTRY', item, index)"
                  :class="index == industryClassifyDict.activeIndex ? 'active-tag' : ''"
                  class="tag-group-item right-margin cursor-default">{{item.dictLabel}}</span>
          </el-row>
          <el-row class="bottom-margin" justify="start" type="flex">
            <span class="tag-group-item right-margin">结算类型：</span>
            <span v-for="(item, index) in settlementTypeDict.list"
                  :key="index" @click="handleTagChange('SETTLEMENT', item, index)"
                  :class="index == settlementTypeDict.activeIndex ? 'active-tag' : ''"
                  class="tag-group-item right-margin cursor-default">{{item.dictLabel}}</span>
          </el-row>
		  <!-- <el-row class="bottom-margin" justify="start" type="flex">
		    <span class="tag-group-item right-margin">需求类型：</span>
		    <span v-for="(item, index) in requirementTypeDict.list"
		          :key="index" @click="handleTagChange('REQUIREMENTTYPE', item, index)"
		          :class="index == requirementTypeDict.activeIndex ? 'active-tag' : ''"
		          class="tag-group-item right-margin cursor-default">{{item.dictLabel}}</span>
		  </el-row> -->
        </div>
        <div class="card-group-foot font-normal bottom-margin">
          <el-row justify="start" type="flex" class="font-small">
            <span class="tag-group-item">排序：</span>
            <span v-for="item in sortItems.list" @click="handleSortItemClick(item)"
                  :class="[item.index == sortItems.list.length - 1 ? '' : 'right-border',
                           item.index == sortItems.activeIndex ? 'font-focus' : 'font-info']"
                  :key="item.index" class="tag-group-item hover-text-decorator">{{item.label}}&nbsp;
              <i v-if="item.index == sortItems.activeIndex"
                 :class="item.asc ? 'el-icon-top' : 'el-icon-bottom'"/>
            </span>
          </el-row>
        </div>
        <!-- 需求列表 -->
        <el-card v-for="(item, index) in requirementList"
                 :key="index" shadow="hover"
                 class="bottom-margin list-item customFadeInDown delay-0-2s slow" :style="(item.status == 2 || item.isApplied==0)?'background-color:#eceaea':''">
          <div @click="toDetail(item.id)">
            <el-row class="list-item-title" justify="space-between" type="flex">
              <span class="hover-text-decorator">{{item.name}}</span>
              <!--<span class="font-red" v-if="item.settlementType == 0">￥ {{item.amount}} /单</span>-->
              <!--<span class="font-red" v-else>总价： ￥ {{item.amount}}</span>-->
			  <span v-if="item.requirementType == 0" style="display:none;"><span style="color:red;" v-if="item.status == 2 || item.isApplied==0">名额已满</span><span style="color:red;" v-else>可抢包</span><img src="../../assets/requirement/icon_c.png"></span>
			  <span v-else  style="display:none;"><span style="color:red;" v-if="item.status == 2 || item.isApplied==0">名额已满</span><span style="color:red;" v-else>可抢包</span><img src="../../assets/requirement/icon_i.png"></span>
            </el-row>
            <el-row class="list-item-info bottom-margin" justify="space-between" type="flex">
              <span class="font-small font-info">
                浏览：{{item.click ? item.click : 0}}<el-divider direction="vertical"/>需要坐席：{{item.agentDemand}}人</span>
              <span class="font-small font-info">更新时间：{{item.updateTime}}</span>
            </el-row>
            <el-row class="list-item-info" justify="space-between" type="flex">
              <span class="font-small font-info">
                行业：{{item.industryClassifyLabel}}<el-divider direction="vertical"/>需求类型：{{item.serviceTypeLabel}}</span>
            </el-row>
            <!--<el-row class="list-item-desc" justify="space-between" type="flex">
              <p class="font-small text-left">{{item.demand}}</p>
            </el-row>-->
          </div>
        </el-card>
        <el-pagination
          :background="true"
          :hide-on-single-page="true"
          :page-size="queryParams.pageSize"
          :total="queryParams.total"
          @current-change="handlePageChange"
          class="bottom-margin"
          layout="prev, pager, next"/>
      </el-col>
      <el-col :span="4" class="aside-container">
        <!-- 重点需求推荐 -->
        <recommend class="customFadeInDown delay-0-2s slow"/>
        <!-- 服务优势 -->
        <!-- <el-card class="bottom-margin customFadeInDown delay-0-1s slow" shadow="never">
          <el-row class="font-bold">
            <div style="font-size: 30px; margin-bottom: 30px;">服务优势</div>
          </el-row>
          <el-row class="bottom-margin" justify="start" type="flex">
            <div class="right-margin">
              <img src="../../assets/requirement/mian.png">
            </div>
            <div class="vertical-flex-box">
              <div class="title-font font-bold">免费发布需求</div>
              <div class="desc-font font-info">所有需求类型，免费发布</div>
            </div>
          </el-row>
          <el-row class="bottom-margin" justify="start" type="flex">
            <div class="right-margin">
              <img src="../../assets/requirement/yan.png">
            </div>
            <div class="vertical-flex-box">
              <div class="title-font font-bold">专业服务商</div>
              <div class="desc-font font-info">万千服务商任由选择</div>
            </div>
          </el-row>
          <el-row class="bottom-margin" justify="start" type="flex">
            <div class="right-margin">
              <img src="../../assets/requirement/money.png">
            </div>
            <div class="vertical-flex-box">
              <div class="title-font font-bold">担保交易</div>
              <div class="desc-font font-info">满意后付款，全程保障</div>
            </div>
          </el-row> 
        </el-card>-->
		<el-image :src="adv" style="display:none;"></el-image>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {getRequirementList} from '@/api/requirement/requirement'
  import {getDictDataByType} from '@/api/common/common'
  import recommend from '@/components/requirement/recommend.vue'
  import {mapState} from "vuex"
  import connect from '@/util/connect.js'

  export default {
    data() {
      return {
		banner:require("../../assets/requirement/banner_new.png"),
		adv:require("../../assets/requirement/adv.png"),
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          orderByColumn: "isApplied",
          isAsc: "desc",
          total: null,
          name: null,
          industryClassify: null,
          serviceType: null,
          settlementType: null,
		  isPublish:true
		},
        sortItems: {
          activeIndex: 0,
          list: [
            {label: "综合", value: 'is_applied', index: 0, asc: ""},
            {label: "发布时间", value: 'publish_date', index: 1, asc: true},
            {label: "浏览量", value: 'click', index: 2, asc: true}
          ]
        },
        requirementList: [],
        settlementTypeDict: {                     // 结算类型
          activeIndex: 0,
          list: []
        },
        serviceTypeDict: {                        // 服务类型
          activeIndex: 0,
          list: []
        },
        industryClassifyDict: {                   // 行业类别
          activeIndex: 0,
          list: []
        },
        requirementTypeDict: {                   // 需求类别
          activeIndex: 0,
          list: []
        }
      }
    },
	created(){
		connect.$emit('updateAdTopShow',false);  
	},
    mounted() {
      this.initPage()
    },
    components: {
      recommend
    },
    computed: {
      ...mapState({
        searchText: state => state.requirement.searchText
      })
    },
    methods: {
      // 页面初始化的操作
      initPage() {
        // 初始化列表数据(这里需要处理header搜索框的内容)
        if (this.searchText) this.queryParams.name = this.searchText
        this.getRequirementList()

        // 初始化字典数据
        getDictDataByType("settlement_type").then(res => {
          if (res.data.code == 0) {
            this.settlementTypeDict.list = [{dictValue: '', dictLabel: '全部'}]
            this.settlementTypeDict.list = this.settlementTypeDict.list.concat(res.data.data)
          } else {
            this.$message.error("获取数据失败")
          }
        })
        getDictDataByType("service_type").then(res => {
          if (res.data.code == 0) {
            this.serviceTypeDict.list = [{dictValue: '', dictLabel: '全部'}]
            this.serviceTypeDict.list = this.serviceTypeDict.list.concat(res.data.data)
          } else {
            this.$message.error("获取数据失败")
          }
        })
        getDictDataByType("industry_classify").then(res => {
          if (res.data.code == 0) {
            this.industryClassifyDict.list = [{dictValue: '', dictLabel: '全部'}]
            this.industryClassifyDict.list = this.industryClassifyDict.list.concat(res.data.data)
          } else {
            this.$message.error("获取数据失败")
          }
        })
		getDictDataByType("requirement_type").then(res => {
		  if (res.data.code == 0) {
		    this.requirementTypeDict.list = [{dictValue: '', dictLabel: '全部'}]
		    this.requirementTypeDict.list = this.requirementTypeDict.list.concat(res.data.data)
		  } else {
		    this.$message.error("获取数据失败")
		  }
		})

        // 订阅header.vue中的查询条件
        this.$store.subscribe((mutation, state) => {
          if (mutation.type == "SET_SEARCH_TEXT") {
            this.queryParams.name = state.requirement.searchText
            this.getRequirementList()
          }
        })
      },
      // 查询标签切换
      handleTagChange(dictType, item, index) {
        switch (dictType) {
          case 'SERVICE':
            this.serviceTypeDict.activeIndex = index
            this.queryParams.serviceType = item.dictValue
            break
          case 'INDUSTRY':
            this.industryClassifyDict.activeIndex = index
            this.queryParams.industryClassify = item.dictValue
            break
          case 'SETTLEMENT':
            this.settlementTypeDict.activeIndex = index
            this.queryParams.settlementType = item.dictValue
            break
		  case 'REQUIREMENTTYPE':
		    this.requirementTypeDict.activeIndex = index
		    this.queryParams.requirementType = item.dictValue
		    break
          default:
            break
        }
        this.getRequirementList()
      },
      handleSortItemClick(sortItem) {
        if (sortItem.index == this.sortItems.activeIndex) {
          this.sortItems.list[sortItem.index].asc = !this.sortItems.list[sortItem.index].asc
        } else {
          this.sortItems.activeIndex = sortItem.index
        }
        this.queryParams.orderByColumn = sortItem.value
        this.queryParams.isAsc = sortItem.asc ? 'asc' : 'desc'
        this.getRequirementList()
      },
      // 跳转到详情页
      toDetail(reqId) {
        this.$router.push({path: "/reqdetail/:id", name: 'requirementDetail',params: {id: reqId}})
      },
      // 获取需求列表
      getRequirementList() {
        getRequirementList(this.queryParams).then(res => {
          if (res.data.code == 0) {
            this.requirementList = res.data.rows
            this.queryParams.total = res.data.total
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          this.$message.error(err.msg)
        })
      },
      // 翻页
      handlePageChange(pageNum) {
        this.queryParams.pageNum = pageNum
        this.getRequirementList()
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/common.css";
  @import "../../assets/css/animation.css";

  .background-white {
    background-color: white;
  }

  .aside-container {
    padding-left: 10px;
  }

  .list-item-title {
    margin-bottom: 20px;
  }

  .list-item-title span {
    font-size: 20px;
  }

  .image-card {
    margin: 10px 1px 1px 1px;
    border-radius: 5px;
	margin-top:0px;
  }

  .tag-group-item {
    height: 25px;
    line-height: 25px;
    padding: 0 10px;
    border-radius: 5px;
  }

  .active-tag {
    background-color: #045df4;
    color: white;
  }

  .right-border {
    border-right: 1px solid #E4E7ED;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .title-font {
    font-size: 18px;
    color: #0b0b0b;
  }
  .desc-font {
    font-size: 13px;
  }
</style>
